
const axios = require('axios');
import Config from '../../Config.js';


// *****************************************
// Create Instance
// *****************************************
const axiosV2 = axios.create({
    baseURL: Config.SETTINGS.API_V2_URL,
    headers: {
        'Content-Type': 'application/json',
        //'Authorization': 'bearer ' + store.state.access_token //window.getCookie('token'),
    }
});


export const apiPost= (url,data,hideSuccessAlert) => {

    return apiRequest('post',url,data,{},hideSuccessAlert);
}

export const apiPatch= (url,data,hideSuccessAlert) => {

    return apiRequest('patch',url,data,{},hideSuccessAlert);
}


export const apiDelete= (url,data,hideSuccessAlert) => {

    return apiRequest('delete',url,data,{},hideSuccessAlert);
}

export const apiRequest = (method, url, data, config = {},hideSuccessAlert = false) => {
    return new Promise((resolve, reject) => {

        const params = {
            ...{
                method: method,
                url: url,
                data: data
            }, ...config
        }

        return axiosV2(params).then(response => {
            if (response?.status == 201 || response?.status == 200) {
                // GET = read-only: dispatch with a non-toasting code so the global
                // spinner still hides but no "saved successfully" notification pops
                const isRead = String(method).toLowerCase() === 'get';
                const event = new CustomEvent('s_apiSuccess', { detail: isRead ? 'read_success' : 'resource_created' });
                if (!hideSuccessAlert)
                    document.dispatchEvent(event);
            }
            return resolve(response.data)
        })
        .catch(httpError => {            
           
            if (config && config.showDefaultError !== false) {
                const event = new CustomEvent('s_apiError', { detail: httpError });
                document.dispatchEvent(event);
            }
            console.error(httpError.message)
            reject(httpError)
        })
    })
}
if (localStorage.getItem('tenantId')) {
    axiosV2.defaults.headers.common['x-tenant-id'] = localStorage.getItem('tenantId')
}

// *****************************************
// Interceptor 
// catch 401|400 errors
// *****************************************
axiosV2.interceptors.response.use(response => {
    return response;
}, error => {
    try {
        //a frozen account (root admin → הקפאה): the api refuses everything but the app shell with
        //frozen: true - tell App.vue so the blocking modal comes up at once, also in a session that
        //was live when the freeze happened
        if (error && error.response && error.response.data && error.response.data.frozen)
            document.dispatchEvent(new CustomEvent('planupAccountFrozen'));

        // if (error.response.status === 401 && error.response.statusText == 'Unauthorized') {
        //     console.log('axios.interceptors.response 401 triggered - logging off')
        //     // store.dispatch('logoff')
        // }
        // console.log(error.response.data.statusCode, error.response)
        if ([400, 500, 404].includes(error.response.data.statusCode)) {
            return Promise.reject({
                message: error.response.data.message,
                statusCode: error.response.data.statusCode
            })
        }
        return Promise.reject(error.response);
    } catch (e) {
        console.error('axios.interceptors.preflight probably ', e)
    }
});




export default axiosV2